export default "__VITE_ASSET__DKkJqrJK__"